import { EmptyStatePanel } from '@playforge/ui';
import { Card, Page } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <Page title="Page not found">
      <Card>
        <EmptyStatePanel
          heading="We couldn't find that page"
          primaryAction={{ content: 'Back to dashboard', onAction: () => navigate('/') }}
        >
          <p>The page you are looking for does not exist.</p>
        </EmptyStatePanel>
      </Card>
    </Page>
  );
}
